import { css } from '@emotion/react';

interface ZIndex {
  [name: string]: number;
}

const elements: ZIndex = {
  alert: 1000,
  loading: 600,
  modal: 500,
  sider: 110,
  header: 100,
};

export const scFunctionZIndex = (name: string) => css`
  z-index: ${elements[name]};
`;
